import React, { useCallback } from 'react';
import { CollectionServer, CollectionServerMobile, FilterToQueryParameters, JSXMap, QueryOrder, QueryParametersToFilters, useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useSearchParams } from 'react-router-dom';

import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../../../common/Context';
import PageLayout from '../../../../../components/PageLayout';

import TabsMenu from '../../../../../components/TabsMenu';
import CapsuleMenu from '../../../../../components/CapsuleMenu';
import { useBreadcrumbs, useMenuLevelOneContext, useMenuLevelThreeContext, useMenuLevelTwoContext } from '../../../../../../common/Context';
import EventListItem from '../../../../../components/EventListItem';

dayjs.locale('ru');
var _ = require('lodash');

export default function PromouterEvents(props) {
    const sourceKey = "promouter";
    const auth = useAuth();
    let [searchParams, setSearchParams] = useSearchParams();
    const onChangeRequestParameters = (value) => {
        if (value) {
            setSearchParams(value)
        }
    }

    const filters = React.useCallback(() => QueryParametersToFilters(searchParams, [
        {
            label: "Дата начала",
            name: "nachaloSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,

            sorted: "ASC",
        },
        {
            label: "Дата окончания",
            name: "okonchanieSorevnovaniya",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
            filtered: [dayjs(), dayjs().add(1, "years")],
        },
        {   // Тип мероприятия
            label: "Тип мероприятия",
            name: "tipMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Уровень мероприятия
            label: "Уровень мероприятия",
            name: "urovenMeropriyatiya",
            filterType: "group",
            display: (o) => o.opisanie,
            sort: true,
            filter: true
        },
        {   // Место проведения
            label: "Место проведения",
            name: "mestoProvedeniya",
            filterType: "group",
            display: (o) => o.name,
            sort: true,
            filter: true
        },
        // {   
        //     label: "Региональное отделение",
        //     name: "organizatorRegionalnoeOtdelenie",
        //     source: "/papi/fed/ro/list",
        //     filterType: "group",
        //     display: (o) => o.nazvanie,
        //     queryFilter: [
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true
        // },
        // {   
        //     label: "Организатор",
        //     name: "organizatorMeropriyatiya",
        //     source: "/papi/fed/org/list",
        //     filterType: "group",
        //     display: (o) => o.nazvanie,
        //     queryFilter: [
        //         QueryOrder("nazvanie", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true
        // },
        // {   
        //     label: "Школа",
        //     name: "organizatorShkola",
        //     source: "/papi/fed/school/list",
        //     filterType: "group",
        //     display: (o) => o.nazvanieShkoliTantsev,
        //     queryFilter: [
        //         QueryOrder("nazvanieShkoliTantsev", "ASC"),
        //     ],
        //     sort: true,
        //     filter: true
        // },
        {
            label: "Категория",
            type: "object",
            relation: {
                reference: {
                    object: "KategoriiUchastnikov",
                    queryFilter: [
                        QueryOrder("opisanie", "ASC"),
                    ],
                }
            },
            name: "kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie.kategoriyaUchastnikov",
            filterType: "group",
            display: (o) => o.opisanie,
            // sort: true,
            filter: true
        }
    ]), [searchParams]);
    const ConvertFilterToQueryParameters = useCallback((value) => {
        if (onChangeRequestParameters) {
            onChangeRequestParameters(FilterToQueryParameters(filters(), value.filter, value.sorting, value.page, value.count))
        }
    }, [onChangeRequestParameters])
    const QueryParametersToPage = useCallback(() => {
        if (searchParams)
            return searchParams.get("page") || 1;
    }, [searchParams]);
    const QueryParametersToPageCount = useCallback(() => {
        if (searchParams)
            return searchParams.get("count") || 15;
    }, [searchParams]);

    const FilterFromContextFilter = React.useCallback(() => [
        // QueryParam("w-nu-OrganizatorFederatsiya", 0),
        // If((dance && dance.length > 0), QueryParam("w-in-KategoriiUchastnikovNaMeropriyatiyakhMeropriyatie.TantsevalnayaDistsiplina.VidTantsa.Tanets", dance?.join(","))),
    ], []);

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    // ----------------------------------------
    const breadcrumbs = useBreadcrumbs()
    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if (count >= i) return p;
            if (!arr[idx]?.context) {
                count++
            }
            p += `/${arr[idx]?.uuid}`
        }
        return p
    }
    // ----------------------------------------

    return (
        <div className="subcontent">
            <div className={"content"}>
                <PageLayout hideSider={true} hideBreadcrumbs={true}>
                    <div style={{ height: "100%", overflowY: "auto", backgroundColor: "white", borderRadius: "4px", padding: "10px" }}>

                        {/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}

                        <CollectionServerMobile
                            // noheader={true}
                            title={"Мероприятия"}
                            auth={auth}
                            name={"Meropriyatiya"}
                            source={`/api/meropriyatiya/list/${sourceKey}`}
                            contextFilters={FilterFromContextFilter}
                            filters={filters}
                            onChangeRequestParameters={ConvertFilterToQueryParameters}
                            page={QueryParametersToPage}
                            count={QueryParametersToPageCount}
                            size={"small"}

                            customRender={(items, {
                                collection,
                                setCollection,
                                setCollectionItem,
                                removeCollectionItem,
                                collectionActions,
                                modelActions,
                                update
                            }) => (<div>
                                {JSXMap(items, (item, idx) => {
                                    return (<EventListItem
                                        key={idx}
                                        event={item}
                                        // qr={item.Data}
                                        // tickets={ticket()}
                                        // adminButton={() => `event-admin/${item.ID}`}
                                        // adminButton={true}
                                        extButtons={({ path, size, style }) => [
                                            <div key="view">
                                                <a
                                                    style={style}
                                                    className={`btn btn-soft-secondary btn-sm`}
                                                    href={`${path(1)}/${item.ID}`}
                                                >
                                                    Просмотр
                                                </a>
                                            </div>
                                        ]}
                                        size={(idx === 0) ? "large" : "medium"}
                                    />)
                                })}
                            </div>)}
                        />
                    </div>
                </PageLayout>
            </div>
            <div className={"footer"}>
                <CapsuleMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} />
            </div>
        </div>)
}
